import { Inject, Injectable } from '@angular/core';
import {
	AbstractConfigService,
	AlarisApiService,
	AlarisFilesService,
	CONFIG_SERVICE_INJECTOR
} from '@campaign-portal/components-library';
import { HttpClient } from '@angular/common/http';
import { from, Observable, of, switchMap } from 'rxjs';
import { FilesParseResponse, FilesUploadResponse } from '@campaign-portal/namespace/entities/files/specs';
import { map } from 'rxjs/operators';
import { FileInfo } from '@campaign-portal/namespace/common/fileInfo';

@Injectable({
	providedIn: 'root'
})
export class ImportRatesFileService extends AlarisFilesService {
	base64String: string | null = null;
	file?: File;
	constructor(
		http: HttpClient,
		@Inject(CONFIG_SERVICE_INJECTOR) config: AbstractConfigService,
		readonly api: AlarisApiService
	) {
		super(http, config);
	}

	uploadFile(provider: string, file?: FileInfo): Observable<FilesUploadResponse> {
		return from(this.getFileBase64(this.file)).pipe(
			switchMap((base64Data) => {
				this.base64String = base64Data; // сохраняем в свойство
				const params = {
					Filename: file?.name,
					Filedata: base64Data,
					provider: provider
				};
				return this.api.loader<FilesUploadResponse>('ImportRates.ImportFile', params);
			}),
			map((resp) => {
				return {
					Success: !!resp.Data,
					Total: resp.Total,
					Data: resp.Data
				};
			})
		);
	}

	override upload(file: File): Observable<FilesUploadResponse> {
		this.file = file;
		return of({
			Success: true,
			Total: 1,
			Data: {
				id: '',
				name: file.name,
				size: file.size
			}
		});
	}

	override parse(): Observable<FilesParseResponse> {
		return of();
	}

	getFileBase64(file?: File): Promise<string> {
		return new Promise((resolve, reject) => {
			const reader = new FileReader();
			reader.onload = (): void => {
				const result = reader.result as string;
				const base64Data = result.split(',')[1]; // извлекаем только Base64 часть
				resolve(base64Data);
			};
			reader.onerror = (error): void => {
				reject(error);
			};
			if (file) {
				reader.readAsDataURL(file);
			}
		});
	}
}